import React from 'react';

interface IconProps {
    className?: string;
    size?: number;
}

const CheckBadgeIcon: React.FC<IconProps> = ({ className = "", size = 24 }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`shrink-0 ${className}`}
        >
            <path
                d="M10.6179 1.32138C11.3911 0.582195 12.6089 0.582195 13.3821 1.32138L15.4873 3.33412C15.7926 3.62597 16.1824 3.8137 16.6009 3.8704L19.4872 4.26142C20.5471 4.40502 21.3065 5.35721 21.2106 6.42256L20.9496 9.32342C20.9117 9.74406 21.008 10.1659 21.2246 10.5284L22.7184 13.0288C23.267 13.947 22.996 15.1344 22.1033 15.7237L19.6726 17.3282C19.3201 17.5609 19.0504 17.8992 18.902 18.2946L17.8785 21.0214C17.5026 22.0229 16.4054 22.5513 15.3881 22.2208L12.618 21.3208C12.2163 21.1903 11.7837 21.1903 11.382 21.3208L8.61195 22.2208C7.59464 22.5513 6.49736 22.0229 6.12149 21.0214L5.09803 18.2946C4.94963 17.8992 4.67986 17.5609 4.3274 17.3282L1.89666 15.7237C1.00397 15.1344 0.732959 13.947 1.28157 13.0288L2.77539 10.5284C2.99199 10.1659 3.08827 9.74406 3.05042 9.32342L2.78939 6.42256C2.69353 5.35721 3.45287 4.40502 4.51284 4.26142L7.39906 3.8704C7.81757 3.8137 8.20739 3.62597 8.51266 3.33412L10.6179 1.32138Z"
                fill="#082F8A"
            />
            <path
                d="M16 9L10.5 14.5L8 12"
                stroke="white"
                strokeWidth="1.6666"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CheckBadgeIcon;
